exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.FaqClientMultiple[data-v-9bb075aa] {\n  height: 100%;\n}\n", "", {"version":3,"sources":["/Users/junya/sunnyeee/sciseed/sAIFaqAdmin/src/components/FaqClientMultiple.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd","file":"FaqClientMultiple.vue","sourcesContent":["\n.FaqClientMultiple[data-v-9bb075aa] {\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9bb075aa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FaqClientMultiple.vue
// module id = myMT
// module chunks = 0